import { syncAllSubDeptToAxd, syncAllSubDeptStudentToAxd, syncAllSubDeptParentToAxd, deleteSubDeptFromAxd, deleteSubDeptStudentFromAxd, deleteSubDeptParentFromAxd, syncAxdDeptItem, syncAxdStudentItem, syncAxdParentItem, uploadAxdStudentPhotoItem, deleteAxdDeptItem, deleteAxdStudentItem, deleteAxdParentItem, getAxdDeptDetailPage, getAxdStudentDetailPage, getAxdParentDetailPage, getAxdDeptSyncLogPage, getAxdDeptSyncLog, getAxdDeptSyncLogDetailPage, deleteAxdDeptSyncLog, getAxdStudentSyncLogPage, getAxdStudentSyncLog, getAxdStudentSyncLogDetailPage, deleteAxdStudentSyncLog, getAxdParentSyncLogPage, getAxdParentSyncLog, getAxdParentSyncLogDetailPage, deleteAxdParentSyncLog } from '../../api/modules/integration';
import {
  DEPT_ORG_TYPE_LABELS,
  formatDeptOrgTypeLabel,
  buildStatsDetailColumns,
} from '../TbSync/tbSyncApiMap';

/** 奥讯达批量同步冷却分钟数（与后端固定值一致，仅批量按钮倒计时）。创建于 2026-06-13 */
export const AXD_SYNC_COOLDOWN_MINUTES = 5;

/** 实体 ID 列 */
export const AXD_SYNC_ENTITY_ID_PROPS = ['studentId', 'departmentId', 'studentParentId'];

/** 奥讯达平台 ID 列 */
export const AXD_SYNC_VENDOR_ID_PROPS = ['vendorGid', 'vendorCid', 'vendorStudentId', 'vendorUid', 'vendorParentId'];

export function isAxdSyncEntityIdProp(prop) {
  return AXD_SYNC_ENTITY_ID_PROPS.includes(prop);
}

export function isAxdSyncVendorIdProp(prop) {
  return AXD_SYNC_VENDOR_ID_PROPS.includes(prop);
}

export function formatAxdSyncVendorIdDisplay(val) {
  if (val == null) return '';
  const text = String(val).trim();
  return text;
}

export function formatAxdSyncCellDisplay(val) {
  if (val == null) return '';
  const text = String(val).trim();
  return text;
}

/** 同步明细跳过说明默认文案 */
export const AXD_SYNC_SKIP_DEFAULT_MESSAGE = '所属班级未同步到奥讯达，已跳过';

export function formatAxdSyncRemarkDisplay(row) {
  if (!row) return '';
  const msg = row.resultMessage;
  if (msg != null && msg !== '') return msg;
  const operation = String(row.operation || '');
  if (operation === '跳过') return AXD_SYNC_SKIP_DEFAULT_MESSAGE;
  return '';
}

export const AXD_SYNC_RESULT_COL_MIN_WIDTH = 68;
export const AXD_SYNC_REMARK_COL_MIN_WIDTH = 120;

export const AXD_SYNC_LOG_RESULT_COLUMN = {
  prop: '_syncResult',
  label: '结果',
  minWidth: AXD_SYNC_RESULT_COL_MIN_WIDTH,
  align: 'center',
  headerAlign: 'center',
  columnType: 'syncResult',
};

export const AXD_SYNC_LOG_REMARK_COLUMN = {
  prop: 'resultMessage',
  label: '说明',
  minWidth: AXD_SYNC_REMARK_COL_MIN_WIDTH,
  columnType: 'remark',
};

export function buildAxdSyncLogDetailColumns(columns) {
  return [...columns, AXD_SYNC_LOG_RESULT_COLUMN, AXD_SYNC_LOG_REMARK_COLUMN];
}

/** 同步记录面板 UI 文案。创建于 2026-06-13 */
export const AXD_SYNC_LOG_PANEL_UI = {
  recordId: '记录ID',
  status: '状态',
  success: '成功',
  fail: '失败',
  skip: '跳过',
  syncTime: '同步时间',
  triggerUser: '触发人',
  action: '操作',
  viewDetail: '查看明细',
  viewCountDetail: '点击查看明细',
  delete: '删除',
  loading: '正在加载汇总信息…',
  triggerUserLabel: '触发人：',
  syncTimeLabel: '同步时间：',
  all: '全部',
  onlySuccess: '仅成功',
  onlyFail: '仅失败',
  onlySkip: '仅跳过',
  refresh: '刷新',
  search: '搜索',
  close: '关闭',
  deleteCurrent: '删除本条',
  detailDialogTitle: '同步记录明细',
  searchPlaceholderFallback: '关键词',
  statusRunning: '进行中',
  statusDone: '已完成',
  statusFailed: '失败',
  deleteConfirmTitle: '提示',
  deleteConfirmMessage: '确认删除同步记录 {nameHint}（编号 {id}）及其全部明细？',
  deletedMsg: '已删除',
  deleteFailedMsg: '删除失败',
  skipDetailLegacyHint: '本条记录仅有跳过汇总（{count} 条），未保存逐条明细；重新同步后可查看跳过说明。',
};

export const axdSyncApiMap = {
  dept: {
    label: '部门架构',
    deptColumnLabel: '学校',
    statsDetailSearchPlaceholder: '部门名称 / 部门ID',
    detailSearchPlaceholder: '部门名称 / 部门ID',
    triggerSync: (params) => syncAllSubDeptToAxd(params),
    triggerDelete: (params) => deleteSubDeptFromAxd(params),
    syncItem: (params) => syncAxdDeptItem(params),
    deleteItem: (params) => deleteAxdDeptItem(params),
    getDetailItemId: (row) => row.departmentId,
    getLogPage: getAxdDeptSyncLogPage,
    getLog: getAxdDeptSyncLog,
    getDetailPage: getAxdDeptSyncLogDetailPage,
    deleteLog: deleteAxdDeptSyncLog,
    getStatsDetailPage: getAxdDeptDetailPage,
    statsDetailColumns: buildStatsDetailColumns([
      { prop: 'departmentName', label: '部门名称', minWidth: 110 },
      { prop: 'deptOrgType', label: '类型', minWidth: 64, align: 'center', headerAlign: 'center' },
      { prop: 'departmentId', label: '部门ID', minWidth: 160 },
      { prop: 'vendorGid', label: '奥讯达年级ID', minWidth: 100 },
      { prop: 'vendorCid', label: '奥讯达班级ID', minWidth: 100 },
    ]),
    normalizeStatsDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        departmentId: g('departmentId', 'DepartmentId'),
        departmentName: g('departmentName', 'DepartmentName'),
        deptOrgType: formatDeptOrgTypeLabel(g('deptOrgType', 'DeptOrgType')),
        vendorGid: g('vendorGid', 'VendorGid'),
        vendorCid: g('vendorCid', 'VendorCid'),
        isSynced: !!(g('isSynced', 'IsSynced')),
      };
    },
    confirmMessage: '确认将所选范围内的年级与班级同步到奥讯达吗？<br/>学校/校区/学段=子树内全部年级班级；年级=该年级及下属班级；班级=该班及父年级。',
    deleteConfirmMessage: '确认从奥讯达批量删除当前范围内已同步的年级/班级吗？<br/>仅删除<strong>厂家侧数据</strong>并清除<strong>同步映射</strong>，本地部门数据保留。',
    skipHint: '',
    detailColumns: buildAxdSyncLogDetailColumns([
      { prop: 'departmentName', label: '部门名称', minWidth: 100 },
      { prop: 'deptOrgType', label: '类型', minWidth: 64, align: 'center', headerAlign: 'center' },
      { prop: 'operation', label: '操作', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'departmentId', label: '部门ID', minWidth: 160 },
      { prop: 'vendorGid', label: '奥讯达年级ID', minWidth: 128 },
      { prop: 'vendorCid', label: '奥讯达班级ID', minWidth: 128 },
    ]),
    normalizeDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        departmentId: g('departmentId', 'DepartmentId'),
        departmentName: g('departmentName', 'DepartmentName'),
        deptOrgType: formatDeptOrgTypeLabel(g('deptOrgType', 'DeptOrgType')),
        operation: g('operation', 'Operation'),
        isSuccess: !!(g('isSuccess', 'IsSuccess')),
        vendorGid: g('vendorGid', 'VendorGid'),
        vendorCid: g('vendorCid', 'VendorCid'),
        resultMessage: g('resultMessage', 'ResultMessage'),
      };
    },
  },
  student: {
    label: '学生',
    deptColumnLabel: '班级',
    statsDetailSearchPlaceholder: '姓名 / 卡号 / 班级',
    detailSearchPlaceholder: '姓名 / 卡号 / 班级',
    triggerSync: (params) => syncAllSubDeptStudentToAxd(params),
    triggerDelete: (params) => deleteSubDeptStudentFromAxd(params),
    syncItem: (params) => syncAxdStudentItem(params),
    uploadPhotoItem: (params) => uploadAxdStudentPhotoItem(params),
    deleteItem: (params) => deleteAxdStudentItem(params),
    getDetailItemId: (row) => row.studentId,
    getLogPage: getAxdStudentSyncLogPage,
    getLog: getAxdStudentSyncLog,
    getDetailPage: getAxdStudentSyncLogDetailPage,
    deleteLog: deleteAxdStudentSyncLog,
    getStatsDetailPage: getAxdStudentDetailPage,
    statsDetailColumns: buildStatsDetailColumns([
      { prop: 'studentName', label: '姓名', minWidth: 80 },
      { prop: 'cardNumber', label: '卡号', minWidth: 88 },
      { prop: 'departmentName', label: '班级', minWidth: 96 },
      { prop: 'studentId', label: '学生ID', minWidth: 160 },
      { prop: 'vendorUid', label: '奥讯达UID', minWidth: 88 },
    ]),
    normalizeStatsDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        studentId: g('studentId', 'StudentId'),
        studentName: g('studentName', 'StudentName'),
        stuCode: g('stuCode', 'StuCode'),
        cardNumber: g('cardNumber', 'CardNumber'),
        departmentName: g('departmentName', 'DepartmentName'),
        vendorStudentId: g('vendorStudentId', 'VendorStudentId'),
        vendorUid: g('vendorUid', 'VendorUid'),
        isSynced: !!(g('isSynced', 'IsSynced')),
        hasUploadableHeadPhoto: !!(g('hasUploadableHeadPhoto', 'HasUploadableHeadPhoto')),
      };
    },
    confirmMessage: "确认要同步当前节点及子部门下的学生到奥讯达平台吗？<br/><span style='color:red'>请先同步部门架构；班级未同步的学生将跳过。</span>",
    deleteConfirmMessage: '确认从奥讯达批量删除当前范围内已同步的学生吗？<br/>仅删除<strong>厂家侧数据</strong>并清除<strong>同步映射</strong>，本地学生/家长数据保留。',
    skipHint: '（班级未映射时的在读学生数）',
    detailColumns: buildAxdSyncLogDetailColumns([
      { prop: 'studentName', label: '姓名', minWidth: 72 },
      { prop: 'cardNumber', label: '卡号', minWidth: 88 },
      { prop: 'departmentName', label: '班级', minWidth: 88 },
      { prop: 'operation', label: '操作', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'studentId', label: '学生ID', minWidth: 160 },
      { prop: 'vendorUid', label: '奥讯达UID', minWidth: 88 },
    ]),
    normalizeDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        studentId: g('studentId', 'StudentId'),
        studentName: g('studentName', 'StudentName'),
        stuCode: g('stuCode', 'StuCode'),
        cardNumber: g('cardNumber', 'CardNumber'),
        departmentName: g('departmentName', 'DepartmentName'),
        operation: g('operation', 'Operation'),
        isSuccess: !!(g('isSuccess', 'IsSuccess')),
        vendorStudentId: g('vendorStudentId', 'VendorStudentId'),
        vendorUid: g('vendorUid', 'VendorUid'),
        resultMessage: g('resultMessage', 'ResultMessage'),
      };
    },
  },
  parent: {
    label: '家长',
    deptColumnLabel: '班级',
    statsDetailSearchPlaceholder: '姓名 / 手机号 / 学生姓名',
    detailSearchPlaceholder: '姓名 / 手机号',
    triggerSync: (params) => syncAllSubDeptParentToAxd(params),
    triggerDelete: (params) => deleteSubDeptParentFromAxd(params),
    syncItem: (params) => syncAxdParentItem(params),
    deleteItem: (params) => deleteAxdParentItem(params),
    getDetailItemId: (row) => row.studentParentId,
    getLogPage: getAxdParentSyncLogPage,
    getLog: getAxdParentSyncLog,
    getDetailPage: getAxdParentSyncLogDetailPage,
    deleteLog: deleteAxdParentSyncLog,
    getStatsDetailPage: getAxdParentDetailPage,
    statsDetailColumns: buildStatsDetailColumns([
      { prop: 'parentName', label: '姓名', minWidth: 80 },
      { prop: 'studentName', label: '学生姓名', minWidth: 80 },
      { prop: 'phone', label: '手机号', minWidth: 100 },
      { prop: 'relationDesc', label: '关系', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'studentParentId', label: '家长ID', minWidth: 140 },
      { prop: 'vendorParentId', label: '奥讯达家长ID', minWidth: 100 },
    ]),
    normalizeStatsDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        studentParentId: g('studentParentId', 'StudentParentId'),
        parentName: g('parentName', 'ParentName'),
        studentName: g('studentName', 'StudentName'),
        phone: g('phone', 'Phone'),
        relationDesc: g('relationDesc', 'RelationDesc'),
        studentId: g('studentId', 'StudentId'),
        vendorParentId: g('vendorParentId', 'VendorParentId'),
        isSynced: !!(g('isSynced', 'IsSynced')),
      };
    },
    confirmMessage: "确认要同步当前节点及子部门下的家长到奥讯达平台吗？<br/><span style='color:orange'>班级未同步则跳过；班级已同步时未同步的学生会自动补同步。手机号为空仍会跳过。</span>",
    deleteConfirmMessage: '确认从奥讯达批量删除当前范围内已同步的家长吗？<br/>仅删除<strong>厂家侧数据</strong>并清除<strong>同步映射</strong>，本地家长数据保留。',
    skipHint: '（学生未映射时的家长数）',
    detailColumns: buildAxdSyncLogDetailColumns([
      { prop: 'parentName', label: '姓名', minWidth: 72 },
      { prop: 'phone', label: '手机号', minWidth: 96 },
      { prop: 'relationDesc', label: '关系', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'operation', label: '操作', minWidth: 56, align: 'center', headerAlign: 'center' },
      { prop: 'studentParentId', label: '家长ID', minWidth: 160 },
      { prop: 'vendorParentId', label: '奥讯达家长ID', minWidth: 88 },
    ]),
    normalizeDetail(row) {
      const g = (a, b) => (row[a] !== undefined && row[a] !== null ? row[a] : row[b]);
      return {
        studentParentId: g('studentParentId', 'StudentParentId'),
        parentName: g('parentName', 'ParentName'),
        phone: g('phone', 'Phone'),
        studentId: g('studentId', 'StudentId'),
        relationDesc: g('relationDesc', 'RelationDesc'),
        operation: g('operation', 'Operation'),
        isSuccess: !!(g('isSuccess', 'IsSuccess')),
        vendorParentId: g('vendorParentId', 'VendorParentId'),
        resultMessage: g('resultMessage', 'ResultMessage'),
      };
    },
  },
};

export { DEPT_ORG_TYPE_LABELS, formatDeptOrgTypeLabel };

/** 兼容 PascalCase / camelCase 的主记录归一化 */
export function normalizeAxdSyncLogPayload(r) {
  if (!r) return null;
  const g = (a, b) => (r[a] !== undefined && r[a] !== null ? r[a] : r[b]);
  return {
    id: g('id', 'Id'),
    rootDepartmentId: g('rootDepartmentId', 'RootDepartmentId'),
    rootDepartmentName: g('rootDepartmentName', 'RootDepartmentName'),
    status: Number(g('status', 'Status')),
    successCount: g('successCount', 'SuccessCount') || 0,
    failCount: g('failCount', 'FailCount') || 0,
    skipCount: g('skipCount', 'SkipCount') || 0,
    startTime: g('startTime', 'StartTime'),
    endTime: g('endTime', 'EndTime'),
    errorMessage: g('errorMessage', 'ErrorMessage'),
    triggerUserId: g('triggerUserId', 'TriggerUserId'),
    triggerUserName: g('triggerUserName', 'TriggerUserName'),
  };
}

/** 解析同步开始时间用于冷却期计算 */
export function parseAxdSyncStartTime(startTime) {
  if (!startTime) return null;
  const normalized = String(startTime).replace(/-/g, '/');
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

/** 计算冷却剩余秒数；进行中返回 -1 */
export function calcAxdCooldownRemainSeconds(latestLog) {
  if (!latestLog) return 0;
  if (Number(latestLog.status) === 0) return -1;
  const start = parseAxdSyncStartTime(latestLog.startTime);
  if (!start) return 0;
  const remainMs = AXD_SYNC_COOLDOWN_MINUTES * 60 * 1000 - (Date.now() - start.getTime());
  return remainMs > 0 ? Math.ceil(remainMs / 1000) : 0;
}

export function formatAxdCooldownText(remainSeconds) {
  if (remainSeconds === -1) return '同步进行中，请稍候';
  if (remainSeconds <= 0) return '';
  const m = Math.floor(remainSeconds / 60);
  const s = remainSeconds % 60;
  if (m > 0) return `${m} 分 ${s} 秒后可再次同步`;
  return `${s} 秒后可再次同步`;
}
